<template>
    <div id="logo">
        <a href="https://www.pari.go.jp/" target="_blank">
            <img border="0"
                :src="pari_icon_path" width="32" height="32" alt="ロゴ">
        </a>
    </div>
</template>

<script>
import config from '../config/config.js'
import path from 'path'

const pari_icon_default_path = '/static/img/pari_icon.png';
export default {
  name: 'Logo',
  computed: {
      pari_icon_path() {
          return path.join(config.DOMAIN, config.PREFIX, pari_icon_default_path);
      }
  }
}
</script>

<style scoped>
#logo {
    padding: 4px;
}
</style>
